import PropTypes from 'prop-types';
import React from 'react';

import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { renderJoinedGroup } from '../../../pages/MyNetwork/sharedConstants';
import Trees from '../../Icons/UserProfile/Trees';
import { GroupCondensedPropShape } from '../../Includes/GroupPropsShape';
import { LOGIN_LAYOUT } from '../../Login/LoginLayoutComponent/LoginLayoutComponent';
import CommonBox, { LeftRailButton } from '../CommonBox/CommonBox';

import './GroupsBox.scss';

const createGroupObject = (group) => ({
    group,
    userRelation: { role: 'member' },
});

export class GroupsBox extends React.PureComponent {
    static propTypes = {
        /**
         * number of groups
         */
        groupCount: PropTypes.number.isRequired,
        /**
         * array of joined groups
         */
        groups: PropTypes.arrayOf(PropTypes.shape(GroupCondensedPropShape))
            .isRequired,
    };

    static defaultProps = {
        groups: [],
        groupCount: 0,
    };

    handleGroupRedirect = () => {
        if (!this.props.groupCount) {
            window.location = '/groups/search';
            return;
        }

        window.location = '/my-network/my-groups';
    };

    renderDescription = () => {
        const { groupCount, isLoggedIn } = this.props;
        const emptyStateDescription =
            'Discover and join groups with like-minded women who share your interests, profession, and lifestyle.';

        return isLoggedIn() && groupCount ? '' : emptyStateDescription;
    };

    renderLoggedInGroupContent = () => {
        const fiveJoinedGroups = this.props.groups.slice(0, 5);
        const newGroupsArray = fiveJoinedGroups.map(createGroupObject);
        const buttonText = this.props.groupCount ? 'Manage' : 'Explore';

        return (
            <React.Fragment>
                <ul className="groups-list">
                    {newGroupsArray.map(renderJoinedGroup(false))}
                </ul>
                <LeftRailButton
                    text={buttonText}
                    onClick={this.handleGroupRedirect}
                />
            </React.Fragment>
        );
    };

    renderLoggedOutGroupContent = () => {
        return this.props.wrapAuth(
            'leftrail-groups',
            LeftRailButton({ text: 'Explore' }),
            { login_trigger: 'leftrail-groups' },
            null,
            LOGIN_LAYOUT
        );
    };

    render() {
        const countLabel = this.props.groupCount
            ? `(${this.props.groupCount})`
            : '';
        const title = this.props.isLoggedIn()
            ? `YOUR GROUPS ${countLabel}`
            : 'YOUR GROUPS';

        return (
            <div className="component-LeftRail-GroupsBox">
                <CommonBox
                    svg={<Trees />}
                    title={title}
                    description={this.renderDescription()}
                >
                    {this.props.isLoggedIn()
                        ? this.renderLoggedInGroupContent()
                        : this.renderLoggedOutGroupContent()}
                </CommonBox>
            </div>
        );
    }
}

export default (props) => (
    <PageConsumer>
        {(pageContext) => (
            <GroupsBox
                {...props}
                isLoggedIn={pageContext.isLoggedIn}
                featureFlags={
                    pageContext.pageProps && pageContext.pageProps.featureFlags
                }
                wrapAuth={pageContext.wrapAuth}
            />
        )}
    </PageConsumer>
);
